import { useMemo } from "react";

interface RestoredStoresData {
  stores: unknown[];
  offset: number;
  hasMore: boolean;
}

/** sessionStorage에서 복원 (restoredData 계산). 위치가 바뀌면 저장 데이터 무효화 */
export function useHomeRestoredStores(currentLocationKey: string | null) {
  return useMemo(() => {
    try {
      const savedStores = sessionStorage.getItem("home:allStores");
      const savedOffset = sessionStorage.getItem("home:offset");
      const savedHasMore = sessionStorage.getItem("home:hasMore");
      const savedLocationKey = sessionStorage.getItem("home:locationKey");

      // 위치가 변경되었으면 저장된 데이터 무효화
      if (savedLocationKey !== currentLocationKey) {
        sessionStorage.removeItem("home:allStores");
        sessionStorage.removeItem("home:offset");
        sessionStorage.removeItem("home:hasMore");
        sessionStorage.removeItem("home:locationKey");
        return null;
      }

      if (savedStores && savedOffset != null && savedHasMore != null) {
        const parsedStores = JSON.parse(savedStores) as unknown[];
        return {
          stores: parsedStores,
          offset: parseInt(savedOffset, 10),
          hasMore: savedHasMore === "true",
        } as RestoredStoresData;
      }
    } catch (error) {
      console.error("Failed to restore from storage:", error);
    }
    return null;
  }, [currentLocationKey]);
}
